export default "__VITE_ASSET__D964TVtt__"